import React from "react";
import { Form, Input, Tabs, Card, Typography } from 'antd';
import { GlobalOutlined, FileTextOutlined } from '@ant-design/icons';
import styles from '../../styles/Description.module.css';

const { TextArea } = Input;
const { Text, Title } = Typography;

const Description = ({
    listingData,
    handleChange,
    errors,
    t,
}) => {
    const tabItems = [
        {
            key: 'en',
            label: (
                <span className={styles.tabLabel}>
                    <GlobalOutlined className={styles.tabIcon} />
                    <span>English</span>
                </span>
            ),
            children: (
                <div className={styles.tabContent} style={{ backgroundColor: '#fafafa' }}>
                    <div style={{ marginBottom: '12px' }}>
                        <Title level={5} style={{ margin: 0, marginBottom: '4px', color: '#262626' }}>
                            Property Description (English) <span style={{ color: '#ff4d4f' }}>*</span>
                        </Title>
                        <Text type="secondary" style={{ fontSize: '13px' }}>
                            Provide a detailed and compelling description of the property
                        </Text>
                    </div>

                    <Form.Item
                        validateStatus={errors?.description ? "error" : ""}
                        help={errors?.description?.[0]}
                        style={{ marginBottom: '8px' }}
                    >
                        <TextArea
                            rows={6}
                            name="description"
                            value={listingData.description}
                            onChange={handleChange}
                            placeholder="Describe the property's features, location advantages, nearby amenities, and unique selling points..."
                            className={styles.textarea}
                            style={{
                                borderColor: errors?.description ? '#ff4d4f' : '#d9d9d9',
                            }}
                            showCount
                            maxLength={2000}
                        />
                    </Form.Item>

                    {listingData.description && (
                        <Text type="success" style={{ fontSize: '12px' }}>
                            ✓ English description added
                        </Text>
                    )}
                </div>
            ),
        },
        {
            key: 'gr',
            label: (
                <span className={styles.tabLabel}>
                    <FileTextOutlined className={styles.tabIcon} style={{ color: '#52c41a' }} />
                    <span>Ελληνικά (Greek)</span>
                </span>
            ),
            children: (
                <div className={styles.tabContent} style={{ backgroundColor: '#f6ffed' }}>
                    <div style={{ marginBottom: '12px' }}>
                        <Title level={5} style={{ margin: 0, marginBottom: '4px', color: '#262626' }}>
                            Περιγραφή Ακινήτου (Ελληνικά) <span style={{ color: '#ff4d4f' }}>*</span>
                        </Title>
                        <Text type="secondary" style={{ fontSize: '13px' }}>
                            Δώστε λεπτομερή και ελκυστική περιγραφή του ακινήτου
                        </Text>
                    </div>

                    <Form.Item
                        validateStatus={errors?.description_gr ? "error" : ""}
                        help={errors?.description_gr?.[0]}
                        style={{ marginBottom: '8px' }}
                    >
                        <TextArea
                            rows={6}
                            name="description_gr"
                            value={listingData.description_gr}
                            onChange={handleChange}
                            placeholder="Περιγράψτε τα χαρακτηριστικά του ακινήτου, τα πλεονεκτήματα της τοποθεσίας, τις κοντινές ανέσεις και τα μοναδικά σημεία πώλησης..."
                            className={styles.textarea}
                            style={{
                                borderColor: errors?.description_gr ? '#ff4d4f' : '#b7eb8f',
                            }}
                            showCount
                            maxLength={2000}
                        />
                    </Form.Item>

                    {listingData.description_gr && (
                        <Text type="success" style={{ fontSize: '12px' }}>
                            ✓ Ελληνική περιγραφή προστέθηκε
                        </Text>
                    )}
                </div>
            ),
        },
    ];

    return (
        <Card
            title={
                <span style={{ fontSize: '16px', fontWeight: 600 }}>
                    Property Description
                </span>
            }
            className={styles.descriptionCard}
        >
            <Tabs
                defaultActiveKey="en"
                items={tabItems}
                size="large"
                className={styles.descriptionTabs}
                animated={{ inkBar: true, tabPane: true }}
                tabBarGutter={8}
            />
        </Card>
    );
};

export default Description;